<script lang="ts">
  import Select from '../../../../../components/select/Select.svelte'
  import { ThreeItemKeys } from '../../../../../constants/three'
  import i18n from '../../../../../i18n'
  import usePrinterQueries from '../../../hooks/usePrinterQueries'
  import InputLabel from '../InputLabel.svelte'
  import SectionContainer from '../SectionContainer.svelte'
  import { PrinterService } from '../../../../../services'
  import type { PrinterOption } from '../../../../../services/printer-drivers/base-printer-driver'
  import Separator from '../../../../../components/separator/Separator.svelte'
  import ControlGroup from '../../../../../components/control-group/ControlGroup.svelte'
  import ControlGroupContent from '../../../../../components/control-group/ControlGroupContent.svelte'

  const { printerId }: { printerId: string } = $props()

  const { usePrinter, changePrinterOptionMutation } = usePrinterQueries()
  const printerQuery = $derived(usePrinter(printerId))
  let printer = $derived(printerQuery.data)
  let printerDriver = $derived(
    printer
      ? PrinterService.getPrinterDriver(
        printer.userData[ThreeItemKeys.PRINTER_MODEL],
      )
      : null,
  )
  let printerOptions = $derived(printerDriver?.printerOptions ?? {})
  let printerOptionEntries = $derived(
    Object.entries(printerOptions) as [string, PrinterOption][],
  )
</script>

{#if printer && printerOptionEntries.length > 0}
  <Separator />
  <SectionContainer title={$i18n.t('project.rightBar.printerSettings.title')}>
    {#each printerOptionEntries as [optionKey, optionDef] (optionKey)}
      <ControlGroup>
        <InputLabel>
          {$i18n.t(
            `project.rightBar.printerSettings.options.${optionKey}`,
            optionKey,
          )}
        </InputLabel>
        <ControlGroupContent>
          <Select
            value={(printer.userData[ThreeItemKeys.PRINTER_OPTIONS] ?? {})[
              optionKey
            ]
              ?? optionDef.default
              ?? optionDef.options[0]}
            name={optionKey}
            onchange={value =>
              changePrinterOptionMutation.mutate({
                objectUuid: printerId,
                optionKey,
                optionValue: value as string,
              })}
            options={optionDef.options.map((opt: string) => ({
              value: opt,
              label: $i18n.t(
                `project.rightBar.printerSettings.options.${optionKey}_${opt}`,
                opt.toUpperCase(),
              ),
            }))}
          />
        </ControlGroupContent>
      </ControlGroup>
    {/each}
  </SectionContainer>
{/if}
